<!-- src/App.vue -->
<template>
  <!-- 渲染 Home 组件（首页） -->
  <Home />
</template>

<script lang="ts" setup>
// 导入 Home.vue 组件（确保 Home.vue 也在 src 根目录，若在子文件夹需调整路径，如 ./views/Home.vue）
import Home from './views/Home.vue';
</script>

<style>
/* 可选：全局通用样式，解决 Tailwind 可能的样式穿透问题 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>
